<template>
  <div class="contents">
    <div class="pdf-uplaod">
      <div class="upload-list" v-for="(img, n) in imgArr" :key="n">
        <template>
          <div
            class="img-body"
            @mouseover="toShowMask(img, n)"
            @mouseout="toHideMask(img, n)"
          >
            <img :src="img.url" alt v-if="img.type == 'image'" />
            <img src="@static/images/cc_pdf_new.png" alt v-else />
            <div class="mask" v-show="img.show">
              <a
                v-if="
                  checkType(img.url) == 'png' ||
                  checkType(img.url) == 'jpg' ||
                  checkType(img.url) == 'jpeg'
                "
                @click="handleView(img.url)"
                >查看</a
              >
              <a @click="download(img)">下载</a>
              <a @click="dele(n)" v-if="!detailFlag">删除</a>
            </div>
          </div>
        </template>
      </div>
      <div class="uploadBox" v-if="!detailFlag">
        <Upload
          ref="upload"
          :show-upload-list="false"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          multiple
          action="/upload/common"
        >
          <Button>上传</Button>
        </Upload>
      </div>
    </div>
    <div class="tip" v-if="!detailFlag">支持PDF、JPG、JPEG或PNG格式</div>
    <Modal
      v-model="visible"
      :footer-hide="true"
      :closable="false"
      :width="modalWidth ? modalWidth : '600px'"
    >
      <div>
        <img
          v-zoom
          v-drag
          :src="curImg"
          v-if="visible"
          class="curImgStyle"
          style="width: 100%"
        />
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props:{
    imgArr: null,
    detailFlag: null,
    modalWidth: null,
    name:{
      default: '下载的文件'
    },
  },
  data: () => ({
    visible: false,
    curImg: "",
  }),
  components: {},
  created() {},
  methods: {
    handleView(item) {
      this.curImg = item;
      this.visible = true;
    },
    checkType(item) {
      return item.split(".").pop().toLowerCase();
    },
    handleBeforeUpload(file) {
      if (!/\.(png|jpg|jpeg|pdf)$/.test(file.name.toLowerCase())) {
        this.$Message.error("上传格式不正确");
        return false;
      }
    },
    handleSuccess(res, file) {
      this.$emit("handleSuccess", res, file);
    },
    dele(index) {
      this.imgArr.splice(index, 1);
    },
    toShowMask(item) {
      item.show = true;
    },
    toHideMask(item, index) {
      item.show = false;
    },
    download(item) {
      this.$units.downloadFun(item,this.name);
    },
  },
};
</script>
<style lang='scss' scoped>
.tip {
  color: #333;
  font-size: 14px;
  margin-top: 10px;
}
.pdf-uplaod {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  .upload-list {
    display: inline-block;
    .img-body {
      width: 150px;
      height: 150px;
      overflow: hidden;
      margin-bottom: 10px;
      img {
        width: 150px;
        height: 150px;
      }
      border-radius: 5px;
      border: 1px solid #ddd;
      margin-right: 10px;
      position: relative;
      .mask {
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        a {
          color: #fff;
            margin-right: 10px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .uploadBox {
    width: 150px;
    height: 150px;
    border: 1px dashed #236dff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  // .right{
  //     margin-left: 20px;
  //     display: inline-block;
  //     .desc{
  //         margin-bottom: 20px;
  //     }
  // }
}
.curImgStyle {
  position: static !important;
}
</style>